var get   = require("object-path").get,
    utils = require("enyo/utils");

module.exports = function(media, aspectRatio) {
    var imageSets,
        i,
        imageSet,
        j,
        bestImage,
        newImage,
        newAspectRatio;

    if (!aspectRatio) {
        return null;
    }

    // Different resolutions of the same image can have slightly different
    // aspect ratio's depending on how their width/height was rounded. Sometimes
    // this causes the aspect ratio of a low-res version to match more closely
    // than a high-res version even though in practice though, a high-res
    // version that's close enough is preferred. In order to mitigate such
    // subtle rounding differences we round aspect ratio down to 2 decimals.
    aspectRatio = Math.round(aspectRatio * 100) / 100;

    // Get all covers.
    imageSets = get(media, "meta.covers", []);

    // If no covers are available, use thumbnails as fallback.
    if (!imageSets.length) {
        imageSets = get(media, "thumbnails", []);
    }

    for (i = 0; i < imageSets.length; i++) {
        imageSet  = imageSets[i].img_set;

        // Sort from largest to smallest image
        imageSet.sort(function(a, b) {
            return a.width * a.height > b.width * b.height ? -1 : 1;
        });

        for (j = 0; j < imageSet.length; j++) {
            newImage       = utils.clone(imageSet[j]);
            newAspectRatio = Math.round(newImage.aspect_ratio * 100) / 100;

            // Aspect ratio isn't significantly different from the current best
            // image, which is guaranteed to be higher res. So we can skip this
            // image.
            if (bestImage && Math.abs(newAspectRatio - bestImage.aspect_ratio) < 0.01) {
                continue;
            }

            // Aspect ratio matches close enough
            if (Math.abs(newAspectRatio - aspectRatio) < 0.01) {
                return newImage;
            }

            // Aspect ratio didn't match, but this is the first image we
            // encounter so it's the best choice by default.
            else if (!bestImage) {
                bestImage       = newImage;
                bestImage.delta = Math.abs(newAspectRatio - aspectRatio);
            }

            // Aspect ratio didn't match. Let's see if it matches better than
            // the previous best match.
            else {
                newImage.delta = Math.abs(newAspectRatio - aspectRatio);

                if (newImage.delta < bestImage.delta) {
                    bestImage = newImage;
                }
            }
        }
    }

    // We don't need this value anymore
    if (bestImage) {
        delete bestImage.delta;
    }

    return bestImage || null;
};
